import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import frontGuard from './front-guard'
import postGuard from './post-guard'
import routes from './routes'
import { routerAnalysisGuard } from '@/plugins/user-analysis/routerAnalysis'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(frontGuard)
router.afterEach((to, from) => {
  postGuard()
  routerAnalysisGuard(to, from)
})

export default router
